<!--推荐有礼用户-->
<template>
	<div class="" style="height:100%">
		<!-- <div class="selectionBar">
			<div class="flex flex-ai-c flex-jc-sb flex-wrap">
				<label>场景：</label>
				<el-input placeholder="用户ID/昵称" v-model="searchValue" size="small" class="input-with-select" style="width:300px">
					<el-button slot="append" icon="el-icon-search" @click="curr=1;getList()"></el-button>
				</el-input>
				<el-input type="number" placeholder="人数满足" v-model="total" size="small" class="input-with-select" style="width:200px">
					<el-button slot="append" icon="el-icon-search" @click="curr=1;getList()"></el-button>
				</el-input>
				<div></div>
			</div>
		</div> -->
		<!-- 表格 -->
		<div class="table" style="height:calc( 100% - 80px )">
			<el-table ref="multipleTable" :data="list" highlight-current-row stripe height="calc( 100% - 40px )">
				<el-table-column prop="headimgurl" label="头像" align="center" show-overflow-tooltip>
					<template slot-scope="scope">
						<el-image :src="getImgUrl(scope.row.user.headimgurl)" fit="cover" style="width:40px; height:40px;border-radius: 3px;" :preview-src-list="[domain + '/' + scope.row.user.headimgurl]">
						</el-image>
					</template>
				</el-table-column>
				<el-table-column prop="user.name" label="姓名" show-overflow-tooltip></el-table-column>
				<el-table-column prop="amount" label="金额" show-overflow-tooltip>
					<template slot-scope="scope">
						<p :style="{color:scope.row.direct=='-'?'':'#EFC43B',fontWeight:'bold'}">{{scope.row.direct+scope.row.amount}}</p>
					</template>
				</el-table-column>
				<el-table-column prop="userTo.name" label="收款人姓名" show-overflow-tooltip></el-table-column>
				<el-table-column prop="create_time" label="转赠时间" show-overflow-tooltip></el-table-column>
			</el-table>
			<!-- 分页 -->
			<div class="paging">
				<el-pagination @current-change="currentChange" @size-change="sizeChange" :current-page="curr" :page-size="row" background layout="total, sizes, prev, pager, next, jumper" :total="count">
				</el-pagination>
			</div>
		</div>


	</div>
</template>

<script>
	export default {
		data() {
			return {
				list: [], //用户列表
				curr: 1, //页码
				row: 20, //每页条数
				pages: 1, //总页数
				count: 0, //总条数
			}
		},
		mounted() {
			//用户列表
			this.getList();

		},
		methods: {
			//用户列表
			getList() {
				this.http.post('/admin/money/index', {
					curr: this.curr,
					row: this.row,
				}).then(res => {
					this.list = res.list;
					this.curr = res.curr;
					this.pages = res.pages;
					this.count = res.count;
				});
			},
			// 图片转换
			getImgUrl(item) {
				var url = this.domain + item;
				return url;
			},

			//翻页
			currentChange: function(curr) {
				this.curr = curr;
				this.getList();
			},
			//改变每页条数
			sizeChange: function(row) {
				this.row = row;
				this.getList();
			},
		}
	}
</script>
